import type { SVGProps } from 'react';
const SvgFormatListNumberedRtl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#format_list_numbered_rtl_svg__a)">
      <path
        fill="currentColor"
        d="M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1Zm1-9h1V4h-2v1h1v3Zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3v1ZM2 5h14v2H2V5Zm0 12h14v2H2v-2Zm0-6h14v2H2v-2Z"
      />
    </g>
    <defs>
      <clipPath id="format_list_numbered_rtl_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormatListNumberedRtl;
